<div class="icon-text flex w-full flex-col items-center gap-4 sm:flex-row">
  <pl-icon
    [class]="iconWidth"
    [ngClass]="{
      'text-pl-orange-500': iconColor === IconColor.plLogoColor,
      'text-pl-blue-500': iconColor === IconColor.primary,
      'text-white': iconColor === IconColor.secondary,
      'text-pl-error': iconColor === IconColor.alert,
      'text-pl-green-500': iconColor === IconColor.success
    }"
    [name]="icon"
    [borderWidth]="IconBorderWidth.big"
    [frame]="iconFrame"
  />
  <div class="flex min-w-0 max-w-full flex-1 flex-col justify-center gap-4">
    <div class="pl-inner-html" [innerHTML]="text"></div>
    <pl-button
      *ngIf="buttonLabel && buttonHref && buttonVariant"
      [padding]="ButtonPadding.big"
      [variant]="buttonVariant"
      class="!w-fit"
      (click)="onButtonClick($event)"
    >
      {{ buttonLabel }}
    </pl-button>
  </div>
</div>
